<ul #sidenav id="slide-out" class="{{ class }} side-nav" >
  <ng-content></ng-content>
  <!-- <div class="sidenav-bg mask-strong"></div>     -->
</ul>
<div (click)="hide()" #overlay id="sidenav-overlay" style="display: none;"></div>


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/pro/sidenav/sidenav.component.html